/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { retrievalsRetrieve } from "../../funcs/retrievalsRetrieve.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.RetrieveParams$inboundSchema,
};

export const tool$retrievalsRetrieve: ToolDefinition<typeof args> = {
  name: "retrievals-retrieve",
  description: `Retrieve`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await retrievalsRetrieve(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
